import { initialState, MENU_LOAD_DATA } from 'store';

export default (state = initialState.menu, { type, payload }) => {
  switch (type) {
    case MENU_LOAD_DATA:
      return payload;
    default:
      return state;
  }
};
